import { Column } from "@/components/common/Table";
import { Badge } from "@/components/ui/badge";
import { Referrals } from "./referrals.types";

/**
 * Map each status to a Tailwind class using CSS variables.
 * Colors are now controlled from index.css only.
 */
const statusClassMap: Record<string, string> = {
  Submitted: "bg-[var(--submitted-bg)] text-[var(--submitted-text)]",
  Campaigned: "bg-[var(--submitted-bg)] text-[var(--submitted-text)]",
  Offered: "bg-[var(--submitted-bg)] text-[var(--submitted-text)]",

  Accepted: "bg-[var(--accepted-bg)] text-[var(--accepted-text)]",
  Scheduled: "bg-[var(--accepted-bg)] text-[var(--accepted-text)]",
  Rescheduled: "bg-[var(--accepted-bg)] text-[var(--accepted-text)]",

  Declined: "bg-[var(--declined-bg)] text-[var(--declined-text)]",
  "No Show": "bg-[var(--declined-bg)] text-[var(--declined-text)]",

  Waitlisted: "bg-[var(--waitlisted-bg)] text-[var(--waitlisted-text)]",

  Visited: "bg-[var(--visited-bg)] text-[var(--visited-text)]",
  "Member Admitted": "bg-[var(--visited-bg)] text-[var(--visited-text)]",
  Admitted: "bg-[var(--visited-bg)] text-[var(--visited-text)]",
  "Diversion Complete": "bg-[var(--visited-bg)] text-[var(--visited-text)]",
  "Report Shared": "bg-[var(--visited-bg)] text-[var(--visited-text)]",

  Cancelled: "bg-[var(--cancelled-bg)] text-[var(--cancelled-text)]",
  Withdrawn: "bg-[var(--cancelled-bg)] text-[var(--cancelled-text)]",
};

/**
 * Badge Component
 */
const StatusBadge = ({ status }: { status: string }) => {
  const classes = statusClassMap[status] ?? "bg-gray-400 text-white";

  return (
    <Badge
      className={`h-[24px] px-[8px] min-w-[100px] max-w-[150px] rounded-[4px] border-none text-[14px] leading-[20px] font-medium font-inter inline-flex items-center justify-center whitespace-nowrap ${classes}`}>
      {status}
    </Badge>
  );
};

export const columns: Column<Referrals>[] = [
  {
    key: "referralDate",
    label: "Referral Date",
    isSortable: false,
    cellClassName: "min-w-[120px]",
    headerClassName: "min-w-[120px]",
    render: (row) => row.referralDate || "-",
  },
  {
    key: "sendingFacility",
    label: "Sending Facility",
    isSortable: false,
    cellClassName: "min-w-[180px]",
    headerClassName: "min-w-[180px]",
    render: (row) => row.sendingFacility || "-",
  },
  {
    key: "receivingFacility",
    label: "Receiving Facility",
    isSortable: false,
    cellClassName: "min-w-[180px]",
    headerClassName: "min-w-[180px]",
    render: (row) => row.receivingFacility || "-",
  },
  {
    key: "referralType",
    label: "Referral Type",
    isSortable: false,
    cellClassName: "min-w-[150px]",
    headerClassName: "min-w-[150px]",
    render: (row) => row.referralType || "-",
  },
  {
    key: "referralStatus",
    label: "Status",
    isSortable: false,
    cellClassName: "min-w-[120px]",
    headerClassName: "min-w-[120px]",
    render: (row) => {
      const status = row.referralStatus || "-";
      return status === "-" ? "-" : <StatusBadge status={status} />;
    },
  },
];
